module.exports = {
  id: 25,
  name: 'Superman Holds',
  categories: ['strength', 'back', 'core'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Strength',
  points: 12,
  instructions:
    'Superman Holds make your back strong! Lie on your stomach, lift your arms and legs up like Superman flying, hold for a few seconds, then lower them down. Keep your head up and imagine you are flying!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to fly like Superman? Let us build incredible back strength!',
    },
    {
      time: 3,
      text: 'Lie on your stomach, arms extended in front of you!',
    },
    {
      time: 6,
      text: 'Keep your head up and get ready to fly!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Lift your arms and legs up like Superman flying!',
    },
    // SET 1 - 6 superman holds
    {
      time: 12,
      text: 'Perfect superman position! Arms extended, legs straight!',
    },
    {
      time: 15,
      text: 'Number 1! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 18,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 21,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 24,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 27,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 30,
      text: 'Number 2! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 33,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 36,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 39,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 42,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 45,
      text: 'Number 3! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 48,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 51,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 54,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 57,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 60,
      text: 'Number 4! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 63,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 66,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 69,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 72,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 75,
      text: 'Number 5! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 78,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 81,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 84,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 87,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 90,
      text: 'Number 6! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 93,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 96,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 99,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 102,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 105,
      text: 'Great job! Take a deep breath and relax your back.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 108,
      text: 'Take a deep breath in and out, you are building incredible back strength!',
    },
    {
      time: 111,
      text: 'Relax your back muscles, get ready for round two!',
    },
    {
      time: 114,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 117,
      text: 'Remember to keep your head up and squeeze your back muscles!',
    },
    {
      time: 120,
      text: '3, 2, 1, START! Lift your arms and legs up like Superman flying!',
    },
    // SET 2 - 6 superman holds
    {
      time: 123,
      text: 'Perfect superman position! Arms extended, legs straight!',
    },
    {
      time: 126,
      text: 'Number 1! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 129,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 132,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 135,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 138,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 141,
      text: 'Number 2! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 144,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 147,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 150,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 153,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 156,
      text: 'Number 3! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 159,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 162,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 165,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 168,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 171,
      text: 'Number 4! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 174,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 177,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 180,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 183,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 186,
      text: 'Number 5! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 189,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 192,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 195,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 198,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 201,
      text: 'Number 6! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 204,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 207,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 210,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 213,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 216,
      text: 'Great job! Take a deep breath and relax your back.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 219,
      text: 'Take a deep breath in and out, you are building incredible back strength!',
    },
    {
      time: 222,
      text: 'Relax your back muscles, get ready for round three!',
    },
    {
      time: 225,
      text: 'You are doing amazing! Ready for round three? Let us keep going!',
    },
    {
      time: 228,
      text: 'Remember to keep your head up and squeeze your back muscles!',
    },
    {
      time: 231,
      text: '3, 2, 1, START! Lift your arms and legs up like Superman flying!',
    },
    // SET 3 - 6 superman holds
    {
      time: 234,
      text: 'Perfect superman position! Arms extended, legs straight!',
    },
    {
      time: 237,
      text: 'Number 1! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 240,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 243,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 246,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 249,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 252,
      text: 'Number 2! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 255,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 258,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 261,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 264,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 267,
      text: 'Number 3! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 270,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 273,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 276,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 279,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 282,
      text: 'Number 4! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 285,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 288,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 291,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 294,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 297,
      text: 'Number 5! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 300,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 303,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 306,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 309,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 312,
      text: 'Number 6! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 315,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 318,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 321,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 324,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 327,
      text: 'Great job! Take a deep breath and relax your back.',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 330,
      text: 'Take a deep breath in and out, you are building incredible back strength!',
    },
    {
      time: 333,
      text: 'Relax your back muscles, get ready for the final round!',
    },
    {
      time: 336,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 339,
      text: 'Remember to keep your head up and squeeze your back muscles!',
    },
    {
      time: 342,
      text: '3, 2, 1, START! Lift your arms and legs up like Superman flying!',
    },
    // SET 4 - 6 superman holds
    {
      time: 345,
      text: 'Perfect superman position! Arms extended, legs straight!',
    },
    {
      time: 348,
      text: 'Number 1! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 351,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 354,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 357,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 360,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 363,
      text: 'Number 2! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 366,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 369,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 372,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 375,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 378,
      text: 'Number 3! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 381,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 384,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 387,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 390,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 393,
      text: 'Number 4! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 396,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 399,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 402,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 405,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 408,
      text: 'Number 5! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 411,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 414,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 417,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 420,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 423,
      text: 'Number 6! Lift your arms and legs up like Superman flying!',
    },
    {
      time: 426,
      text: 'Keep your head up and squeeze your back muscles!',
    },
    {
      time: 429,
      text: 'Hold steady and imagine you are flying through the sky!',
    },
    {
      time: 432,
      text: 'Stay strong, keep your arms and legs lifted!',
    },
    {
      time: 435,
      text: 'Lower down slowly and controlled!',
    },
    {
      time: 438,
      text: 'Incredible work! You just completed all four sets!',
    },
    // COMPLETION
    {
      time: 441,
      text: 'Amazing work! You did 24 superman holds and built incredible back strength!',
    },
    {
      time: 444,
      text: 'You are getting super strong and powerful! You are a flying champion!',
    },
    {
      time: 447,
      text: 'Great job, strength champion! You are building incredible skills!',
    },
  ],
};
